import lessonStatus from '../../config/constants/lessonStatus'

export default function getStatus(mapData) {
  return mapData?.is_available !== 1
    ? lessonStatus.NOT_AVAILABLE
    : mapData.status
}
